import React from "react";
import { Box, Text, Heading, Image, Flex, Grid } from "@chakra-ui/react";
import service15 from "../../../assets/services/service15.jpg";
import service16 from "../../../assets/services/service16.jpg";
import service17 from "../../../assets/services/service17.jpg";
import flower from "../../../assets/services/SVG (1).png";
import flower1 from "../../../assets/services/SVG.png";
import FlowerImage from "component/FlowerImage";
import darkblue from "../../../assets/flower/dark blue.png";

const Service6 = () => {
  return (
    <>
      <Box
        bg="#F7F1E6"
        color="black"
        minH="65vh"
        display="flex"
        alignItems="center"
        px={{ base: 4, md: 16 }}
        position="relative"
      >
        {/* Decorative Flower */}
        <FlowerImage
          src={darkblue}
          top={{ base: "66%", md: "43%" }}
          left={{ base: "65%", md: "70%" }}
          width="30px"
        />

        <Flex
          direction={{ base: "column-reverse", md: "row" }} // Swaps order on mobile
          align="center"
          justify="space-between"
          w="100%"
          maxW="1200px"
          mx="auto"
          gap={8}
        >
          {/* Left: Image Section */}
          <Box
            flex="1"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Grid
              templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }}
              gap={4}
              w="fit-content"
              position="relative"
            >
              {/* Image 1 */}
              <Box
                gridColumn={{ base: "auto", md: "2" }}
                gridRow={{ base: "1", md: "1" }}
              >
                <Image
                  src={service15}
                  alt="Teamwork"
                  borderRadius="3xl"
                  boxShadow="lg"
                  w={{ base: "120px", md: "160px" }}
                  h={{ base: "120px", md: "140px" }}
                  objectFit="cover"
                  className="fade-in-up"
                />
              </Box>

              {/* Image 2 */}
              <Box
                gridColumn="1"
                gridRow="1"
                zIndex="1"
                transform="translateY(30%)"
              >
                <Image
                  src={service16}
                  alt="Planning"
                  borderRadius="3xl"
                  boxShadow="lg"
                  w={{ base: "140px", md: "180px" }}
                  h={{ base: "140px", md: "160px" }}
                  objectFit="cover"
                  className="fade-in-up"
                />
              </Box>

              {/* Image 3 */}
              <Box
                gridColumn="2"
                gridRow="2"
                transform="translateX(-10%)"
                zIndex="2"
              >
                <Image
                  src={service17}
                  alt="Development"
                  borderRadius="3xl"
                  boxShadow="lg"
                  w={{ base: "120px", md: "180px" }}
                  h={{ base: "120px", md: "180px" }}
                  objectFit="cover"
                  className="fade-in-up"
                />
              </Box>
            </Grid>
          </Box>

          {/* Right: Text Section */}
          <Box
            flex="1"
            textAlign={{ base: "center", md: "left" }}
            mb={{ base: 6, md: 0 }}
          >
            <Heading fontSize={{ base: "2xl", md: "3xl" }} mb={4} className="fade-in-up">
            Content Marketing  Storytelling That Drives Business!
            </Heading>

            <Text fontSize={{ base: "sm", md: "md" }} color="gray.700" className="fade-in-up">
            Marwadis are known for their storytelling, and we bring this art to digital marketing! Through blogs, articles, videos, reels, and infographics, we craft compelling narratives that engage your audience and build a strong brand presence.
            </Text>
          </Box>
        </Flex>

        {/* Decorative Flowers */}
        <Image
          src={flower}
          alt="Decorative Flower"
          position="absolute"
          top={{ base: "78%", md: "68%" }}
          left={{ base: "80%", md: "62%" }}
          w={{ base: "50px", md: "90px" }}
          h={{ base: "50px", md: "90px" }}
          className="fade-in-up"
        />
        <Image
          src={flower1}
          alt="Decorative Flower"
          position="absolute"
          top={{ base: "42%", md: "10%" }}
          right={{ base: "73%", md: "43%" }}
          w={{ base: "90px", md: "240px" }}
          h={{ base: "90px", md: "260px" }}
          className="fade-in-up"
        />
      </Box>
    </>
  );
};

export default Service6;
